export const sortFields = [
	'id',
	'parameterRef',
	'label',
	'defaultValue',
	'parameterType',
	'parameterTypeRef',
	'createdAt',
	'updatedAt',
] as const;
